import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { HttpClient, HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { CookieModule } from 'ngx-cookie';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

// Modules
import { AppRoutingModule } from './app-routing.module';
import { CoreModule } from './core/core.module';
import { SharedModule } from './shared/shared.module';


// Components
import { HeaderComponent } from './components/header/header.component';
import { FooterComponent } from './components/footer/footer.component';
import { SideMenuComponent } from './components/side-menu/side-menu.component';
import { AlertsCenterComponent } from './components/alerts-center/alerts-center/alerts-center.component';
import { ListaEventiComponent } from './components/lista-eventi/lista-eventi.component';
import { DettaglioEventoComponent } from './components/dettaglio-evento/dettaglio-evento.component';
import { DettaglioTemplateComponent } from './components/dettaglio-template/dettaglio-template.component';
import { ElencoTemplateComponent } from './components/elenco-template/elenco-template.component';
import { GenericDialogContentComponent } from './components/generic-dialog-content/generic-dialog-content.component';

// Material Widgets
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatTableModule } from '@angular/material/table';
import { MatIconModule, MatIconRegistry } from '@angular/material/icon';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input'
import { MatExpansionModule } from '@angular/material/expansion';
import { DateAdapter, MatNativeDateModule, MAT_DATE_FORMATS } from '@angular/material/core';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatSelectModule } from '@angular/material/select';
import { DatePipe } from '@angular/common';
import { MatPaginatorIntl, MatPaginatorModule } from '@angular/material/paginator';
import { MatSortModule } from '@angular/material/sort';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatButtonModule } from '@angular/material/button';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatDialogModule } from '@angular/material/dialog';
import { MatCardModule } from '@angular/material/card';
import { TestErrorComponent } from './components/test-error/test-error.component';
import { MatTabsModule } from '@angular/material/tabs';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatAutocompleteModule } from '@angular/material/autocomplete';

//Custom Widgets
import { getItaPaginatorIntl } from './translations/custom-paginator';
import { ListaEntiAbilitatiComponent } from './components/lista-enti-abilitati/lista-enti-abilitati.component';
import { SegnalazioneComponent } from './components/segnalazione/segnalazione.component';
import { DettaglioCampoComponent } from './components/dettaglio-campo/dettaglio-campo.component';
import { GestioneSegnalazioniComponent } from './components/gestione-segnalazioni/gestione-segnalazioni.component';
import { ListaSegnalazioniEventoComponent } from './components/lista-segnalazioni-evento/lista-segnalazioni-evento.component';
import { CompilazioneSegnalazioneComponent } from './components/compilazione-segnalazione/compilazione-segnalazione.component';
import { MrfFormModule } from '@eng/morfeo';
import { ImportaTemplateComponent } from './components/importa-template/importa-template.component';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { InviaSegnalazioniComponent } from './components/invia-segnalazioni/invia-segnalazioni.component';
import { LoginComponent } from './components/login/login.component';
import { LogoutComponent } from './components/logout/logout.component';
import { AuthInterceptor } from './core/interceptors/auth.interceptor';
import { StoricoSegnalazioneComponent } from './components/storico-segnalazione/storico-segnalazione.component';
import { APP_DATE_FORMATS } from './shared/components/customDateFormat/pickDateAdapter';
import { MAT_DATE_LOCALE } from '@angular/material/core';
import { LoaderService } from './core/spinner/loader.service';
import { LoaderInterceptor } from './core/spinner/loader.interceptor';
import { MomentDateAdapter } from '@angular/material-moment-adapter';
import { MapComponent } from './components/map/map.component';
import { LeafletModule } from '@asymmetrik/ngx-leaflet';
import { ElencoRichiesteComponent } from './components/elenco-richieste/elenco-richieste.component';
import { DettaglioRichiestaComponent } from './components/dettaglio-richiesta/dettaglio-richiesta.component';
import { SelezioneDpgrDialogComponent } from './components/selezione-dpgr-dialog/selezione-dpgr-dialog.component';
import { ElencoInterventiComponent } from './components/elenco-interventi/elenco-interventi.component';
import { DettaglioInterventoComponent } from './components/dettaglio-intervento/dettaglio-intervento.component';
import { CambioStatoDialogComponent } from './components/cambio-stato-dialog/cambio-stato-dialog.component';
import { ListaCampiUnicaComponent } from './components/lista-campi-unica/lista-campi-unica.component';
import { ModificaStatiEnteDialogComponent } from './components/modifica-stati-ente-dialog/modifica-stati-ente-dialog.component';
import { AnomalieSegnalazioneDialogComponent } from './components/anomalie-segnalazione-dialog/anomalie-segnalazione-dialog.component';
import { DettaglioDateComponent } from './components/dettaglio-date/dettaglio-date.component';
import { CambioRuoloEnteComponent } from './components/cambio-ruolo-ente-dialog/cambio-ruolo-ente-dialog';
import { environment } from 'src/environments/environment';
import { GestioneCampiExportDialogComponent } from './components/gestione-campi-export-dialog/gestione-campi-export-dialog.component';
import { GestioneInvioSegnalazioniComponent } from './components/gestione-invio-segnalazioni/gestione-invio-segnalazioni.component';
import { GestioneUtentiComponent } from './components/gestione-utenti/gestione-utenti.component';
import { UploadFileComponent } from './components/upload-file/upload-file.component';
import { DettaglioSegnalazioneComponent } from './components/dettaglio-segnalazione/dettaglio-segnalazione.component';
import { UploadProtocolloRegionaleComponent } from './components/upload-protocollo-regionale/upload-protocollo-regionale.component';
import { EntiDelegatiComponent } from './components/enti-delegati/enti-delegati.component';
import { CreaUtenteComponent } from './components/crea-utente/crea-utente.component';

@NgModule({
  declarations: [
    AppComponent,
    HeaderComponent,
    FooterComponent,
    SideMenuComponent,
    AlertsCenterComponent,
    ListaEventiComponent,
    DettaglioEventoComponent,
    DettaglioTemplateComponent,
    ElencoTemplateComponent,
    TestErrorComponent,
    GenericDialogContentComponent,
    ListaEntiAbilitatiComponent,
    SegnalazioneComponent,
    DettaglioCampoComponent,
    GestioneSegnalazioniComponent,
    ListaSegnalazioniEventoComponent,
    CompilazioneSegnalazioneComponent,
    ImportaTemplateComponent,
    InviaSegnalazioniComponent,
    LoginComponent,
    LogoutComponent,
    StoricoSegnalazioneComponent,
    MapComponent,
    ElencoRichiesteComponent,
    DettaglioRichiestaComponent,
    SelezioneDpgrDialogComponent,
    CambioRuoloEnteComponent,
    ElencoInterventiComponent,
    DettaglioInterventoComponent,
    CambioStatoDialogComponent,
	  ListaCampiUnicaComponent,
  	ModificaStatiEnteDialogComponent,
    DettaglioDateComponent,
    AnomalieSegnalazioneDialogComponent,
    GestioneCampiExportDialogComponent,
    GestioneInvioSegnalazioniComponent,
    GestioneUtentiComponent,
    UploadFileComponent,
    DettaglioSegnalazioneComponent,
    UploadProtocolloRegionaleComponent,
    EntiDelegatiComponent,
    CreaUtenteComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    CoreModule,
    SharedModule,
    HttpClientModule,
    MatTooltipModule,
    BrowserAnimationsModule,
    MatIconModule,
    MatInputModule,
    MatDatepickerModule,
    MatFormFieldModule,
    MatNativeDateModule,
    MatButtonModule,
    MatIconModule,
    MatTableModule,
    MatExpansionModule,
    MatGridListModule,
    MatSelectModule,
    MatPaginatorModule,
    MatSortModule,
    MatProgressSpinnerModule,
    MatSnackBarModule,
    MatDialogModule,
    MatAutocompleteModule,
    MatCardModule,
    MatTabsModule,
    MatCheckboxModule,
    MrfFormModule,
    LeafletModule,
    CookieModule.forRoot(),
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: httpTranslateLoader,
        deps: [HttpClient]
      }
    })
  ],
  providers: [
    DatePipe,
    { provide: MAT_DATE_LOCALE, useValue: 'it-IT' },
    { provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE] },
    { provide: MAT_DATE_FORMATS, useValue: APP_DATE_FORMATS },
    { provide: MatPaginatorIntl, useValue: getItaPaginatorIntl() },
    { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
    LoaderService,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: LoaderInterceptor,
      multi: true
    }

  ],
  bootstrap: [AppComponent]
})
export class AppModule { }

// AOT compilation support
export function httpTranslateLoader(http: HttpClient) {
  return new TranslateHttpLoader(http, environment.urls.assets, '.json');
}
